import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit_icon--sprite",
  "use": "edit_icon--sprite-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"edit_icon--sprite\">\n    <path d=\"M13.5325 3.27992C13.825 2.98742 13.825 2.49992 13.5325 2.22242L11.7775 0.467422C11.5 0.174922 11.0125 0.174922 10.72 0.467422L9.34 1.83992L12.1525 4.65242L13.5325 3.27992ZM0.25 10.9374V13.7499H3.0625L11.3575 5.44742L8.545 2.63492L0.25 10.9374Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol